"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var checkForIds = function checkForIds(values) {
  if (Array.isArray(values)) {
    var isCorrect = values.every(function (item) {
      return _typeof(item) !== 'object' || Object.prototype.hasOwnProperty.call(item, 'id');
    });
    if (!isCorrect) {
      throw new Error('Every array element should have an ID');
    }
    var _iterator = _createForOfIteratorHelper(values),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        checkForIds(item);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (_typeof(values) === 'object' && values !== null) {
    for (var _i = 0, _Object$values = Object.values(values); _i < _Object$values.length; _i++) {
      var _item = _Object$values[_i];
      checkForIds(_item);
    }
  }
  return true;
};
var _default = exports["default"] = function _default(values, updatedValues) {
  checkForIds(updatedValues);
  function composeObject(obj, updatedObj) {
    if (obj.doNotTraverse || updatedObj.doNotTraverse) {
      updatedObj.doNotTraverse = true;
      return;
    }
    var updatedKeys = Object.keys(updatedObj);
    for (var _i2 = 0, _Object$entries = Object.entries(obj); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (updatedKeys.includes(key)) {
        traverse(obj[key], updatedObj[key]);
      } else {
        updatedObj[key] = value;
      }
    }
  }
  function traverse(obj, updatedObj) {
    if (!obj) {
      return;
    }
    if (Array.isArray(updatedObj)) {
      if (updatedObj.length === 0 || _typeof(updatedObj[0]) !== 'object') {
        return;
      }
      updatedObj.forEach(function (item) {
        var originalItem = obj.find(function (row) {
          return row.id === item.id;
        });
        if (!originalItem) {
          return;
        }
        composeObject(originalItem, item);
      });
    } else if (_typeof(updatedObj) === 'object' && updatedObj !== null) {
      composeObject(obj, updatedObj);
    }
  }
  var result = (0, _cloneDeep2["default"])(updatedValues);
  traverse(values, result);
  return result;
};